import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "imp-wrap" }
const _hoisted_2 = { class: "imp-layout" }
const _hoisted_3 = { class: "imp-list" }
const _hoisted_4 = {
  key: 0,
  class: "imp-muted"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "imp-u-name" }
const _hoisted_7 = {
  key: 0,
  class: "imp-u-badge"
}
const _hoisted_8 = {
  key: 1,
  class: "imp-u-badge off"
}
const _hoisted_9 = {
  key: 1,
  class: "imp-muted"
}
const _hoisted_10 = {
  key: 0,
  class: "imp-detail"
}
const _hoisted_11 = { class: "imp-head" }
const _hoisted_12 = { class: "imp-h-name" }
const _hoisted_13 = { class: "imp-h-mail" }
const _hoisted_14 = {
  key: 0,
  class: "imp-muted"
}
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = {
  key: 1,
  class: "imp-muted"
}
const _hoisted_17 = {
  key: 1,
  class: "imp-detail imp-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "imp-intro" }, " Intră în aplicație „ca\" un utilizator, pe o firmă a lui, ca să vezi exact ce vede el (aceleași drepturi și meniu). Nu ai nevoie de parola lui. Ieși oricând din banda de sus. Fiecare impersonare este jurnalizată. ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          class: "imp-search",
          placeholder: "Caută utilizator..."
        }, null, 512), [
          [_vModelText, _ctx.search]
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Se încarcă..."))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (u) => {
          return (_openBlock(), _createElementBlock("button", {
            key: u.ID,
            class: _normalizeClass(["imp-user", { active: _ctx.selected && _ctx.selected.ID === u.ID }]),
            onClick: ($event: any) => (_ctx.select(u))
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(u.Username), 1),
            (u.SuperAdmin)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "admin"))
              : _createCommentVNode("", true),
            (!u.Active)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "inactiv"))
              : _createCommentVNode("", true)
          ], 10, _hoisted_5))
        }), 128)),
        (!_ctx.loading && !_ctx.filtered.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Niciun utilizator."))
          : _createCommentVNode("", true)
      ]),
      (_ctx.selected)
        ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.selected.Username), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.selected.Email || '—'), 1)
              ])
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "imp-comp-head" }, "Alege firma pe care intri ca acest utilizator:", -1)),
            (_ctx.loadingComp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Se încarcă firmele..."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (c) => {
              return (_openBlock(), _createElementBlock("button", {
                key: _ctx.companyId(c),
                class: "imp-comp",
                disabled: _ctx.busy,
                onClick: ($event: any) => (_ctx.impersonate(c))
              }, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "#ff2c21"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-login-variant", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("span", null, [
                  _cache[2] || (_cache[2] = _createTextVNode("Intră ca ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.selected.Username), 1),
                  _createTextVNode(" @ " + _toDisplayString(c.Name), 1)
                ])
              ], 8, _hoisted_15))
            }), 128)),
            (!_ctx.loadingComp && !_ctx.companies.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Utilizatorul nu are firme asociate. "))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_17, [
            _createVNode(_component_v_icon, {
              size: "48",
              color: "#cbd5e1"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-account-switch-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createElementVNode("p", null, "Selectează un utilizator.", -1))
          ]))
    ])
  ]))
}